import type { FeedbackItem } from '../types';

/**
 * Ticket links: the page a ticket was raised on, plus `#markup-ticket=<id>`.
 *
 * Opening one lands on that page with the ticket open and its pin in view
 * (after signing in, if needed). A hash rather than a query parameter,
 * because it never reaches the host's server or router — no route or cache
 * config needed.
 */
const PARAM = 'markup-ticket';

export function buildTicketLink(feedback: FeedbackItem): string {
  const base =
    feedback.pageMetadata?.url ||
    (typeof window !== 'undefined' ? window.location.href : '');
  try {
    const url = new URL(base);
    url.hash = `${PARAM}=${encodeURIComponent(feedback.id)}`;
    return url.toString();
  } catch (_) {
    return `${base}#${PARAM}=${encodeURIComponent(feedback.id)}`;
  }
}

/** The ticket id in the current URL's hash, if any. */
export function readTicketLink(): string | null {
  if (typeof window === 'undefined') return null;
  const match = window.location.hash.match(new RegExp(`${PARAM}=([^&]+)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/** Drop the ticket hash once handled, without a navigation or history entry. */
export function clearTicketLink(): void {
  if (typeof window === 'undefined' || !readTicketLink()) return;
  const { pathname, search } = window.location;
  window.history.replaceState(window.history.state, '', pathname + search);
}
